import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    headerClassName: '',
    h5HeaderClassName: '',
    sceneClassName: ''
  },
  mutations: {
    toggleHeaderClassName(state, name) {
      state.headerClassName = name;
    },
    toggleH5HeaderClassName(state, name) {
      state.h5HeaderClassName = name;
    },
    toggleSceneClassName(state, name) {
      state.sceneClassName = name;
    }
  },
  actions: {}
});
